import { forwardRef, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ProblemsComponent; }),
    multi: true
};
var ProblemsComponent = /** @class */ (function () {
    function ProblemsComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.appearance = 'outline';
        this.problems = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    ProblemsComponent.prototype.ngOnInit = function () {
        if (this.disabled) {
            this.inputValue.disable();
        }
    };
    ProblemsComponent.prototype.ngOnChanges = function (changes) {
        for (var propertyName in changes) {
            if (propertyName === 'disabled') {
                var disabledValue = changes[propertyName].currentValue;
                if (disabledValue) {
                    this.inputValue.disable();
                }
                else {
                    this.inputValue.enable();
                }
            }
        }
    };
    ProblemsComponent.prototype.writeValue = function (problemId) {
        if (problemId) {
            this.selectedProblem = this.problems.find(function (problem) { return problem.id === problemId; });
            this.inputValue.setErrors(null);
        }
        else {
            this.unselectProblem();
        }
    };
    ProblemsComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ProblemsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ProblemsComponent.prototype.setSelectedProblem = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedProblem = this.problems.find(function (problem) { return problem.id === _this.inputValue.value; });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    ProblemsComponent.prototype.unselectProblem = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedProblem = null;
        this.inputValue.setErrors(null);
    };
    return ProblemsComponent;
}());
export { ProblemsComponent };
